<template>
	<date-picker
		:class="{ 'date-component-round': round }"
		:value="date"
		:disabled-date="disabledPastDates"
		placeholder="dd/mm/aaaa"
		format="DD/MM/YYYY"
		value-type="YYYY-MM-DD"
		@input="$emit('on-input', $event)"
		@clear="$emit('clear', $event)"
	>
		<template v-if="showIcon">
			<span class="icon-calendar-custom" slot="icon-calendar">
				<v-icon size="18">event</v-icon>
				<img v-if="icon" :src="icon" alt="" @error="hideBrokenIcon">
			</span>
		</template>
	</date-picker>
</template>

<script>
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'vue2-datepicker/locale/es';

	function disabledPastDates(date) {
		if (this.disabledPastDate) {
			return date < new Date();
		}
		return false;
	}

	function hideBrokenIcon({ target }) {
		target.classList.add('is-hidden');
	}

	export default {
		name: 'date-component',
		components: {
			DatePicker,
		},
		methods: {
			disabledPastDates,
			hideBrokenIcon,
		},
		props: {
			date: [Date, String],
			disabledPastDate: {
				default: false,
				type: Boolean,
			},
			icon: String,
			round: {
				default: false,
				type: Boolean,
			},
			showIcon: {
				default: true,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.icon-calendar-custom {
		align-items: center;
		display: inline-flex;
		height: 20px;
		justify-content: center;
		position: relative;
		width: 20px;

		img {
			height: 18px;
			position: absolute;
			width: 18px;

			&.is-hidden {
				display: none;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/date-component.vue